import { combineReducers } from 'redux'
import { reducer as addProduct } from './addProduct'
import { reducer as cart } from './cart'
import { reducer as cartId } from './cartId'
import { reducer as cartItemRemove } from './cartItemRemove'
import { reducer as cartItemUpdate } from './cartItemUpdate'
import { reducer as checkoutConfig } from './checkoutConfig'
import { reducer as couponApply } from './couponApply'
import { reducer as couponRemove } from './couponRemove'
import { reducer as giftCardApply } from './giftCardApply'
import { reducer as giftCardRemove } from './giftCardRemove'
import { reducer as giftMessage } from './giftMessage'
import { reducer as giftMessageSave } from './giftMessageSave'
import { reducer as lockCheckout } from './lockCheckout'
import { reducer as paymentMethod } from './paymentMethod'
import { reducer as placeOrder } from './placeOrder'
import { reducer as placeOrderNext } from './placeOrderNext'
import { reducer as setBillingAddress } from './setBillingAddress'
import { reducer as setGuestEmail } from './setGuestEmail'
import { reducer as setShippingAddress } from './setShippingAddress'
import { reducer as setShippingMethod } from './setShippingMethod'
import { reducer as useShippingAddress } from './useShippingAddress'

export const reducer = combineReducers({
  addProduct,
  cart,
  cartId,
  cartItemRemove,
  cartItemUpdate,
  checkoutConfig,
  couponApply,
  couponRemove,
  giftCardApply,
  giftCardRemove,
  giftMessage,
  giftMessageSave,
  lockCheckout,
  paymentMethod,
  placeOrder,
  placeOrderNext,
  setBillingAddress,
  setGuestEmail,
  setShippingAddress,
  setShippingMethod,
  useShippingAddress
})
